import { render, staticRenderFns } from "./SendGift.vue?vue&type=template&id=87c769f6&scoped=true&"
import script from "./SendGift.vue?vue&type=script&lang=js&"
export * from "./SendGift.vue?vue&type=script&lang=js&"
import style0 from "./SendGift.vue?vue&type=style&index=0&id=87c769f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c769f6",
  null
  
)

export default component.exports